import { getContainerStyles, getPointerStyles } from '../../getPointerStyles';
export var popupContentStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'block',
      zIndex: v.zIndex
    }, p.pointing && Object.assign({
      pointerEvents: 'none'
    }, getContainerStyles({
      placement: p.basePlacement,
      padding: v.pointerMargin
    })), p.autoSize && {
      // when autoSize is true, root will have inline style maxWidth and maxHeight set by popper
      display: 'flex'
    });
  },
  pointer: function pointer(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables,
        rtl = _ref2.rtl;
    return getPointerStyles({
      backgroundColor: v.backgroundColor,
      borderColor: v.borderColor,
      borderSize: v.borderSize,
      gap: v.pointerGap,
      padding: v.pointerMargin,
      height: v.pointerHeight,
      width: v.pointerWidth,
      placement: p.basePlacement,
      rtl: rtl
    });
  },
  content: function content(_ref3) {
    var p = _ref3.props,
        v = _ref3.variables;
    return Object.assign({
      display: 'block',
      background: v.backgroundColor,
      color: v.color,
      boxShadow: v.boxShadow,
      border: v.borderSize + " solid " + v.borderColor,
      borderRadius: v.borderRadius,
      padding: v.padding,
      transform: 'rotate(360deg)'
    }, p.pointing && {
      pointerEvents: 'all'
    }, p.autoSize && {
      overflow: 'auto'
    });
  }
};